module.exports = __webpack_public_path__ + "img/Pasarelas21.d795b043.jpg";